export default {
  LOG_DISPATCH: false,
  USE_REDUX_DEVTOOLS: true,
  JSONIFY_OBJECT_OUTPUT: false,
  LOG_CLIENT_CHATTER: false,
  LOG_STORE_VALUE_REDUCER: false,
};



// WEBPACK FOOTER //
// ./lib/rlink-debug-utils/config.js